import { render, staticRenderFns } from "./ENotaInput.vue?vue&type=template&id=d5872e80"
import script from "./ENotaInput.vue?vue&type=script&lang=js"
export * from "./ENotaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports